import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SelectBase } from '@bases/selector/select.base';
import { DocumentRequestModuleType } from '@enums/document-request-module-type.enum';
import { TiimeInputContainerModule, TiimeOptionModule, TiimeSelectModule } from 'tiime-material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentRequestModuleTypeLabelPipe } from '@shared-pipes/document-request-module-type-label/document-request-module-type-label.pipe';

@Component({
  selector: 'app-document-request-type-select',
  standalone: true,
  imports: [
    TiimeOptionModule,
    TiimeInputContainerModule,
    TiimeSelectModule,
    ReactiveFormsModule,
    FormsModule,
    DocumentRequestModuleTypeLabelPipe
  ],
  templateUrl: './document-request-module-type-select.component.html',
  styleUrl: './document-request-module-type-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentRequestModuleTypeSelectComponent extends SelectBase<DocumentRequestModuleType> {
  label = input('Type de demande');
}
